import { isEmail } from "validator";

import { EmailsList } from "./types";

const emailSplitRegex = /[\n ,;]+/;
const gmailEmailRegex = /<.*?>/;

export const extractEmailsFromString = (input: string): EmailsList => {
  const emailList = gmailEmailRegex.test(input) ? extractEmailsFromGmailString(input) : input.split(emailSplitRegex);

  const emails = emailList.map((email) => email.trim()).filter((email) => Boolean(email));

  return emails.reduce((acc, email) => {
    acc[email] = { valid: isEmail(email) };
    return acc;
  }, {} as EmailsList);
};

export const extractEmailsFromGmailString = (input: string): string[] => {
  const pattern = /<([^>]+)>/g;
  const matches = [];
  let match: string[] | null;

  while ((match = pattern.exec(input)) !== null) {
    matches.push(match[1]);
  }

  return matches;
};
